export const iconFontAwesomeTimeCalendarMinus = (
	<i className="fa-solid fa-calendar-minus"></i>
);
